export const SET_Dashboard = "SET_Dashboard";
export const UPDATE_Dashboard = "UPDATE_Dashboard";
export const RESET_SEARCH_STATE = "RESET_SEARCH_STATE";
export const UPDATE_SEARCH_STATE = "UPDATE_SEARCH_STATE";
export const SELECT_TOPIC = "SELECT_TOPIC";
export const THEME_MODE = "THEME_MODE";